<template>
  <app-base-main noPadding parentTable class="profit-statistics-widget-shop">
    <template #filter-group>
      <app-filter-group @reset="$gjReset"
        @query="$gjNoticeQuery"
        :query-loading="queryBtnLoading">
        <gj-country-server-select v-model="filter.countryMarketValue"></gj-country-server-select>
        <gj-select :options="financeCurrencysOption"
          placeholder="币种"
          v-model="filter.currency"
          :clearable="false">
        </gj-select>
        <gj-select-date-picker :type="filter.date.key === 'DAY' ? 'daterange' : 'monthrange'"
          v-model="filter.date"
          :options="dateTypeList"
          :dateClearable="false"
          :shortcut="filter.date.key === 'DAY'">
        </gj-select-date-picker>
        <template #right>
          <gj-tool-group :download="$permission('profitStatistics:export')"
            download-url="/operation/profitStatistics/export"
            :download-params="globalParams"
            help
            setting
            :task="true"
            :table-name="tableName"
            :table-columns="columns"
            :sort-gjtable="$refs.gjTable">
            <template #task-content>
              <profit-statisrics-task ref="task"></profit-statisrics-task>
            </template>
          </gj-tool-group>
          <view-setting :ref="REF_VIEW_SETTING"
            save-mode="remote"
            :use-default="true"
            :module-name="moduleName"
            :config="model"
            :fn-generate-params="generateViewParams"
            @view-complete="handCompleteView"
            @view-change="handleChangeView">
            <template v-slot:dateRange="{ formData }">
              <gj-select style="width: 130px"
                v-model="formData.dateType"
                :options="DATE_TYPE_OPTIONS"
                :clearable="false"
                @change="() => formData.dateRange = 0"></gj-select>
              <gj-select style="margin-left: 8px;width: 130px;"
                v-model="formData.dateRange"
                :options="formData.dateType === 'DAY' ? timeRangeOptions : monthRangeOptions" />
            </template>
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table ref="gjTable"
        size="has-picture"
        adaptParent
        show-summary
        :name="tableName"
        :data="tableData"
        :columns="columns"
        :loading="loading"
        :pagination="pagination"
        :summary-object="statisticRecord"
        :default-sort="{prop: '', order: 'descending'}"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <!-- 自定义cell -->
        <template v-slot:analysis="{ row }">
          <gj-icon iconfont="iconshuju1"
            class="analysis-icon"
            @click.native="handleNavigateShop(row)"></gj-icon>
        </template>
        <template v-slot:platformCost="{ row }">
          <ProfitPopoverPanel title="平台费"
                            :width="'220px'"
                            :data="buildPlatformCost(row)">
            {{(row.currencySymbol || '')}}{{row.platformCost | defaultShow}}
          </ProfitPopoverPanel>
        </template>

        <template v-for="item in loop_fields"  v-slot:[item.field]="{row}">
          <div :key="item.field">
            <DataClickView @dataClick="handleClickColumn(row, item.field)" :text="(row[item.field]) | defaultShow(row[item.prefix],item.suffix)"/>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { isMeaningfulMixin, queryMixin, selectionMixin, noRepeatQueryMixin } from "@/minxins";
import { convertToFullDate } from "@/utils/date.util.js";
import { financeCurrencysOption } from "@/utils/options";
// import { COLUMNS } from "@/views/modules/statistics/profit-statistics/config"
import { COLUMNS_2, loop_fields } from "./columns";
import { profitStatisticsPage } from "@/api/statistics"
import { DATE_SHORTCUTS } from "@/utils/const";
import Recalculation from "@/views/modules/statistics/profit-statistics/components/Recalculation.vue";
import profitStatisricsTask from "@/views/modules/statistics/profit-statistics/task/profit-statisrics-task"
import { DATE_TYPE_OPTIONS, timeRangeOptions, monthRangeOptions } from '@/utils/options'
import viewConfig from './viewConfig/MSKU'
import {convertToDate, convertToMonth} from "@/utils/date.util";
import ProfitPopoverPanel from "./profit-popover-panel.vue";
import DataClickView from '@/views/modules/statistics/common/analysis/goods-analysis/widget/data-click-view';
let COLUMNSMap = COLUMNS_2.filter(item => item.includesType.includes('shop'))
import { generatorTrulyDateTime,dateTypeList, buildPlatform } from './utils'
import OperationAnalysisModalNew from "modules/sale/listing/modal/operation-analysis-modal-new";

export default {
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin, noRepeatQueryMixin, buildPlatform],
  name: "profit-statistics-shop",
  components: {profitStatisricsTask, ProfitPopoverPanel, DataClickView},
  data() {
    return {
      DATE_TYPE_OPTIONS,
      timeRangeOptions,
      monthRangeOptions,
      dateTypeList,
      financeCurrencysOption, // 币种
      loading: false, // 加载
      groupType: "marketId",
      tableName: "profit-statistics-shop",
      statisticRecord: {}, // 合计对象
      tableData: [], // 表格数据
      filter: {
        countryMarketValue: {}, // 店铺国家
        currency: "", // 币种
        date: { key: 'DAY', value: DATE_SHORTCUTS.yesterday.date }, // 时间搜索
      },
      columns: [
        { id: "marketName", header: "店铺/国家", field: "marketName", minWidth: "120px", default: true, fixed: 'left'},
        { id: "analysis", header: "分析", field: "slot:analysis", minWidth: "50px", default: true, fixed: 'left'},
        ...COLUMNSMap
      ],
      moduleName: 'PROFIT-STATISTICS',
      model: viewConfig,
      cacheOptions: {
        useCache: true,
      },
      loop_fields
    };
  },
  created() {
    this.sort.prop = ""
  },
  methods: {
    /**
     * 构造视图参数
     */
    generateViewParams (params) {
      let [ startDateTime = '', endDateTime = '' ] = generatorTrulyDateTime(params.dateType, params.dateRange)
      params.startDateTime = params.dateType === 'DAY' ? convertToDate(startDateTime) : convertToMonth(startDateTime)
      params.endDateTime = params.dateType === 'DAY' ? convertToDate(endDateTime) : convertToMonth(endDateTime)
      return Promise.resolve(params)
    },

    // 初始化,重置
    $gjQueryInitParams() {
      this.filter.countryMarketValue = {};
      this.filter.currency = "";
      this.filter.date.key = "DAY";
      this.filter.date.value = DATE_SHORTCUTS.yesterday.date;
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{ countryMarketValue: *}}
     */
    $gjCacheCallback(params) {
      return {
        countryMarketValue: params.countryMarketValue,
        date: params.date,
        currency: params.currency,
      };
    },
    // 搜索
    $gjQuery() {
      // 构造查询参数
      this.loading = true
      this.queryBtnLoading = true;
      const params = {
        model: {
          groupType: this.groupType,
          countryCodes: this.filter.countryMarketValue.countryIds, // 国家
          marketIds: this.filter.countryMarketValue.marketIds, // 店铺
          currency: this.filter.currency, // 币种
          dateRangType: this.filter.date.key, // 统计日期范围
          startStatisticsDate: null, // 开始时间
          endStatisticsDate: null, // 结束时间
        },
        ...this.querySort,
        ...this.queryPagination,
      };
      if (this.filter.date.key == "DAY" && this.filter.date.value) {
        params.model.startStatisticsDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM-dd')
        params.model.endStatisticsDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM-dd')
      }else {
        params.model.startStatisticsDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM')
        params.model.endStatisticsDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM')
      }
      this.globalParams = params;
      this.profitStatisticsPage(params)
    },
    // 跳转全店铺看板
    handleNavigateShop (row) {
      const params = {
        countryData: {
          countryIds: row.country ? [row.country]: [], // 国家
          marketIds: row.marketId ? [row.marketId]: [], // 店铺
        },
        date: {
          type: this.filter.date.key,
          value: []
        }
      }
      if (this.filter.date.key == "DAY" && this.filter.date.value) {
        params.date.value[0] = convertToFullDate(this.filter.date.value[0], 'yyyy-MM-dd')
        params.date.value[1] = convertToFullDate(this.filter.date.value[1], 'yyyy-MM-dd')
      }else {
        params.date.value[0] = convertToFullDate(this.filter.date.value[0], 'yyyy-MM')
        params.date.value[1] = convertToFullDate(this.filter.date.value[1], 'yyyy-MM')
      }
      this.$router.push({ path: '/statistics/shop-wide-analysis', query: { params: JSON.stringify(params)}})
    },
    // 查询list数据
    async profitStatisticsPage(params) {
      this.loading = true;
      this.queryBtnLoading = true;
      try {
        let res = await profitStatisticsPage(params);
        this.pagination = this.getPagination(res);
        this.tableData = res.records || [];
        this.statisticRecord = res.statisticRecord;
      } finally {
        this.loading = false;
        this.queryBtnLoading = false
      }
    },
    // 重算
    recalculation() {
      this.$gjCreate(Recalculation, {
        props: {},
        on: {
          creact: this.$gjQuery
        }
      });
    },
     /**
     * 显示弹窗
     */
    handleClickColumn(row, field){
      let params =  this.globalParams;

      let groupType = this.asinType;
                  console.log('当前参数是',groupType)

      console.log(row, field, params, groupType)
      this.$gjCreate(OperationAnalysisModalNew,{
        props: {
          params:{
            ...params,
            date:[params.model.startStatisticsDate,params.model.endStatisticsDate],
            groupType:'marketId',
            row:row,
            field:field
          }
          
        }
      })

    },

  },
};
</script>

<style  lang="scss">
.profit-statistics-widget-shop {
  .table-shadow {
    box-shadow: none;
  }
  .date-picker {
    width: 136px;
  }
  .analysis-icon {
    font-size: 21px;
    color: #1F6EEF;
    cursor: pointer;
  }
}
</style>
